// extracted by mini-css-extract-plugin
export default {"stack":"GhePage4TopSummaryCharts_stack__EDj-M"};